import { useMemo } from 'react';
import {
  PerformanceAnalysisDetail,
  PerformanceAnalysisDetailRow,
} from '../types';

export function useDetailFormatData(
  data: PerformanceAnalysisDetail[],
): PerformanceAnalysisDetailRow[] {
  return useMemo(() => {
    return data.map((d) => {
      const student = d.student;
      return {
        studentFullName: `${student.accountLastNames}, ${student.accountNames}`,
        studentIdentificationTypeId: student.identificationTypeId,
        studentIdentificationTypeName: student.identificationTypeName,
        studentIdentificationCountryId: student.identificationCountryId,
        studentIdentificationCountryName: student.identificationCountryName,
        studentIdentificationValue: student.identificationValue,
        studentIdentificationValueFormated: student.identificationValueFormated,
        studyPlanVersionName: d.studyPlanVersion.name,
        finalPartialPercentage: d.grades.finalPartialPercentage,
        partial: d.grades.partial,
        partialPassed: d.grades.partialPassed,
        finalExamPercentage: d.grades.finalExamPercentage,
        exam: d.grades.exam,
        examPassed: d.grades.examPassed,
        final: d.grades.final,
        finalPassed: d.grades.finalPassed,
      };
    });
  }, [data]);
}
